import { connect } from 'react-redux';
import { AddMultipleOfferingsToCartButton } from '../components/AddMultipleOfferingsToCartButton';
import map from 'lodash/map';

import {
  openCartForDesktop,
  saveCartRequest,
  changeVariantQuantity,
} from '../actions';

const offeringToLineItem = quantityMap => offering => {
  return {
    sku: offering.variantSku,
    offeringId: offering.id,
    quantity: quantityMap[offering.id] || 1,
  };
};

export const mapDispatchToProps = (
  dispatch,
  { onClick, offerings, shouldAutoCloseCart = true, quantityMap = {} }
) => ({
  onClick: () => {
    // Convert each offering into a line item. If an offering has an ID
    // entry in the quantityMap, override the default quantity (1), with the
    // entry in said map.
    const lineItems = map(offerings, offeringToLineItem(quantityMap));

    // It may seem redundant to change quantities of pending line items if
    // we're just about to save the cart and wipe them. The reason this is done
    // is so we can show the "(X) items added to your cart" message when in
    // mobile view.
    for (const { offeringId, sku, quantity } of lineItems)
      dispatch(changeVariantQuantity({ sku }, offeringId, quantity));
    dispatch(saveCartRequest(lineItems, true));
    dispatch(openCartForDesktop(shouldAutoCloseCart));
    onClick && onClick();
  },
});

export default connect(
  null,
  mapDispatchToProps
)(AddMultipleOfferingsToCartButton);
